 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import BACKEDTLU_1 from '@/components/Backed/tlu_1'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import INDEX_SPLIT_000 from '@/components/index_split_000'
 import INTRODUCTION from '@/components/introduction'
 import INDEX_SPLIT_001 from '@/components/index_split_001'
 import INDEX_SPLIT_002 from '@/components/index_split_002'
 import INDEX_SPLIT_003 from '@/components/index_split_003'
 import INDEX_SPLIT_004 from '@/components/index_split_004'
 import INDEX_SPLIT_005 from '@/components/index_split_005'
 import INDEX_SPLIT_006 from '@/components/index_split_006'
 import INDEX_SPLIT_007 from '@/components/index_split_007'
 import INDEX_SPLIT_008 from '@/components/index_split_008'
 import INDEX_SPLIT_009 from '@/components/index_split_009'
 import LOVE_2 from '@/components/love_2'
 import INDEX_SPLIT_010 from '@/components/index_split_010'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import ENDMATTER2 from '@/components/endmatter2'
 import ENDMATTER3 from '@/components/endmatter3'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/Backed/tlu_1",
 			"name" : "Backed/tlu_1",
 			"component" : BACKEDTLU_1
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/index_split_000",
 			"name" : "index_split_000",
 			"component" : INDEX_SPLIT_000
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/index_split_001",
 			"name" : "index_split_001",
 			"component" : INDEX_SPLIT_001
 		},
 		{
 			"path" : "/index_split_002",
 			"name" : "index_split_002",
 			"component" : INDEX_SPLIT_002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js